import * as tslib_1 from "tslib";
import React from 'react';
import * as ReactDOM from 'react-dom';
import ddt from '@wix/da-ddt';
import classnames from 'classnames';
import ScrollAware from '../ScrollAware';
import ArrowUp from '../Icons/ArrowUp';
import { IconSize } from '../Icons/IconWrap';
import { BiDiv, BiEventType } from '../biLogger';
import { withPerspectiveContext, } from '../Context/PerspectiveContext';
import s from './BackToTop.scss';
var DEFAULT_APPEAR_HEIGHT = 500;
var BackToTop = /** @class */ (function (_super) {
    tslib_1.__extends(BackToTop, _super);
    function BackToTop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            var _a = _this.props, scrollToY = _a.scrollToY, getScrollableContainer = _a.getScrollableContainer;
            var scrollableContainer = getScrollableContainer();
            var scrollOpts = {
                left: 0,
                top: scrollToY || 0,
                behavior: 'smooth',
            };
            if (scrollableContainer) {
                scrollableContainer.scrollTo(scrollOpts);
            }
            else {
                window.scrollTo(scrollOpts);
            }
        };
        _this.renderButtonBlock = function (scrolled) {
            var getZeroPerspectiveContainer = _this.props.getZeroPerspectiveContainer;
            var zeroPerspectiveContainer = getZeroPerspectiveContainer();
            if (zeroPerspectiveContainer) {
                return ReactDOM.createPortal(_this.renderButton(scrolled), zeroPerspectiveContainer);
            }
            else {
                return _this.renderButton(scrolled);
            }
        };
        _this.renderButton = function (scrolled) {
            var _a = _this.props, className = _a.className, stuckClassName = _a.stuckClassName, biTotalItemsCount = _a.biTotalItemsCount;
            return (React.createElement(BiDiv, { biData: {
                    evid: BiEventType.BACK_TO_TOP,
                    offset: biTotalItemsCount,
                }, onClick: _this.onClick, className: classnames(s['root'], className, scrolled && s['stuck'], scrolled && stuckClassName) },
                React.createElement(ArrowUp, { size: IconSize.SMALL })));
        };
        return _this;
    }
    BackToTop.prototype.render = function () {
        var _this = this;
        var _a = this.props, offset = _a.offset, allowInIframe = _a.allowInIframe;
        // prevent backtoTop inside iframes
        if (!allowInIframe &&
            typeof window !== 'undefined' &&
            window.top !== window.self) {
            ddt.error('backtotop', 'BackToTop wrongly embedded inside iframe. Use prop allowInIframe if you would like it to be shown');
            return null;
        }
        return (React.createElement(ScrollAware, null, function (_a) {
            var scrollTop = _a.scrollTop;
            var scrolled = scrollTop > (offset || DEFAULT_APPEAR_HEIGHT);
            return _this.renderButtonBlock(scrolled);
        }));
    };
    return BackToTop;
}(React.Component));
export default withPerspectiveContext(BackToTop);
//# sourceMappingURL=BackToTop.js.map